export default "__VITE_ASSET__DGN$924D__"